import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ScreenUtilsService } from "core/services";
import { ChecklistDialogComponent } from "./checklist-dialog.component";

export interface IChecklistDialogData<T extends any, TTranslationKey extends string = string> {

    title: TTranslationKey

    defaultBtnText?: TTranslationKey

    defaultCheckAll?: boolean
    displayExpr: keyof T;
    valueExpr: keyof T;
    data: T[]
}


@Injectable({ providedIn: 'root' })
export class ChecklistDialogService<TTranslationKey extends string = string> {
    readonly screenSizeSubject = this._screenUtilsService.screenSizeSubject;
    get screenSize() {
        return this.screenSizeSubject.value;
    }

    constructor(
        private readonly _dialog: MatDialog,
        private readonly _screenUtilsService: ScreenUtilsService
    ) {

    }


    open<T extends any>(data: IChecklistDialogData<T, TTranslationKey>) {
        const dialogRef = this._dialog.open<ChecklistDialogComponent, IChecklistDialogData<T>, T[]>(
            ChecklistDialogComponent,
            {
                data,
                panelClass: !['sm', 'xs'].includes(this.screenSize) ? 'col-min-width-large' : undefined,
                minWidth: ['sm', 'xs'].includes(this.screenSize) ? '100%' : undefined,
                height: ['sm', 'xs'].includes(this.screenSize) ? '100%' : 'auto'
            },

        );
        return dialogRef.afterClosed()
    }

}
